import { Component } from '@angular/core';
import { ConfigurePaymentPlansComponent } from '../../components/agency/subaccounts/configure-payment-plans/configure-payment-plans.component';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule } from '@angular/material/tree';

@Component({
  selector: 'app-rebilling-page',
  standalone: true,
  imports: [ConfigurePaymentPlansComponent, MatTreeModule],
  templateUrl: './rebilling-page.component.html',
  styleUrl: './rebilling-page.component.scss'
})
export class RebillingPageComponent {

}
